import { API_DOMAIN_DEFAULT } from '../../model/model';
import { isNotDefined, getUriParams } from '../../utils/util';
import PowerbookList from './PowerbookList';

class Powerbook {
  constructor(options) {
    const _ = this;

    if (isNotDefined(options)) throw new Error('Powerbook constructor require options object');

    _.option = $.extend({
      wrap: null,
      apiDomain: API_DOMAIN_DEFAULT,
      global: window
    }, options);

    _.global = _.option.global;

    _.locationParams = getUriParams(document.location.href) || {};

    // _.queryStr = (_.locationParams.query || '').trim();
    _.keywordStr = (_.locationParams.keyword || '').trim();

    _.pageIndex = _.locationParams.page || 1;

    _.powerbookList = null;
  }

  init() {
    this.setInstance();

    return this;
  }

  setInstance() {
    this.setPowerbookList();
  }

  setPowerbookList() {
    const _ = this,
      opt = _.option;

    _.powerbookList = new PowerbookList({
      wrap: $('.search-result', opt.wrap),
      apiDomain: opt.apiDomain,
      // queryStr: _.queryStr,
      keywordStr: _.keywordStr,
      pageIndex: _.pageIndex,
      global: opt.global
    }).init();
  }
}

export default Powerbook;


// WEBPACK FOOTER //
// ./_src/js/search/powerbook2/Powerbook.js